import ArticleLayout from '@/pages/article/components/ArticleLayout';
import { allArticles } from '@/mocks/articles';

export default function SugargooBeginnersGuidePage() {
  const article = allArticles.find(a => a.slug === 'sugargoo-beginners-guide')!;
  return <ArticleLayout article={article} />;
}